import { CommonEnums } from '../../common.enums';
import { LAttribute } from './lattribute';
import { VennGroup } from './venngroup';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { Venn_Unon_Inst } from './venn_unon_inst';
import { LAttributesUtil } from 'src/app/shared/grids/lattributes/lattributes.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { VennGroupsUtil } from '../../utils/venngroups.util';
import { Attribute } from './attribute';

export class Union {
    venn_Unon_Inst: Venn_Unon_Inst;

    vennGroups: Array<VennGroup>;
    lAttributes: Array<LAttribute>;
    attributes: Array<Attribute>;

    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;
    is_In_SubFlow: string;

    sel_Run_PropertyType_Cd: string;
    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    change_Ind: string;
    gen_Tab_Change_Ind: string;
    prop_Tab_Change_Ind: string;
    attr_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.venn_Unon_Inst = new Venn_Unon_Inst();

        this.vennGroups = new Array<VennGroup>();
        this.lAttributes = new Array<LAttribute>();

        this.nativeDbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.is_In_SubFlow = CommonEnums.defaults.STRING_EMPTY;

        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.prop_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(unionTmp: Union): Union {
        let union: Union = new Union();
        union.copyFrom(unionTmp);
        return union;
    }

    copy(): Union {
        let unionTmp: Union = new Union();

        unionTmp.venn_Unon_Inst = this.venn_Unon_Inst.copy();

        unionTmp.vennGroups = VennGroupsUtil.getInstance().copy(this.vennGroups);
        unionTmp.lAttributes = LAttributesUtil.getInstance().copy(this.lAttributes);

        unionTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        unionTmp.ref_Id = this.ref_Id;
        unionTmp.ref_Cd = this.ref_Cd;
        unionTmp.fldr_Id = this.fldr_Id;
        unionTmp.is_In_SubFlow = this.is_In_SubFlow;

        unionTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        unionTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);
        unionTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);

        unionTmp.change_Ind = this.change_Ind;
        unionTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        unionTmp.prop_Tab_Change_Ind = this.prop_Tab_Change_Ind;
        unionTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;
        unionTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;

        unionTmp.error_Cd = this.error_Cd;
        unionTmp.error_Msg = this.error_Msg;

        return unionTmp;
    }

    copyFrom(unionTmp: Union): void {
        this.venn_Unon_Inst.copyFrom(unionTmp.venn_Unon_Inst);

        VennGroupsUtil.getInstance().copyFrom(this.vennGroups, unionTmp.vennGroups);
        LAttributesUtil.getInstance().copyFrom(this.lAttributes, unionTmp.lAttributes);

        this.nativeDbTyp_Id = unionTmp.nativeDbTyp_Id;
        this.ref_Id = unionTmp.ref_Id;
        this.ref_Cd = unionTmp.ref_Cd;
        this.fldr_Id = unionTmp.fldr_Id;
        this.is_In_SubFlow = unionTmp.is_In_SubFlow;

        this.sel_Run_PropertyType_Cd = unionTmp.sel_Run_PropertyType_Cd;
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, unionTmp.runPropertyTypes);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, unionTmp.run_Properties);

        this.change_Ind = unionTmp.change_Ind;
        this.gen_Tab_Change_Ind = unionTmp.gen_Tab_Change_Ind;
        this.prop_Tab_Change_Ind = unionTmp.prop_Tab_Change_Ind;
        this.attr_Tab_Change_Ind = unionTmp.attr_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = unionTmp.rProp_Tab_Change_Ind;

        this.error_Cd = unionTmp.error_Cd;
        this.error_Msg = unionTmp.error_Msg;
    }

    comapre(unionTmp: Union): string {
        let diffString: string = this.venn_Unon_Inst.compare(unionTmp.venn_Unon_Inst);
        if (diffString != '') return diffString;

        diffString = this.toBaseCompare(unionTmp);
        if (diffString != '') return diffString;

        diffString = VennGroupsUtil.getInstance().compare(this.vennGroups, unionTmp.vennGroups);
        if (diffString != '') return diffString;

        diffString = LAttributesUtil.getInstance().compare(this.lAttributes, unionTmp.lAttributes);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.run_Properties, unionTmp.run_Properties);
        if (diffString != '') return diffString;

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.runPropertyTypes, unionTmp.runPropertyTypes);
        if (diffString != '') return diffString;

        return '';
    }

    toBaseCompare(unionTmp: Union): string {
        let baseString: string = this.toBaseString();
        let baseTmpString: string = unionTmp.toBaseString();

        if (baseString != baseTmpString) {
            return baseString + ', ' + baseTmpString;
        }

        return '';
    }

    toBaseString(): string {
        return ", nativeDbTyp_Id=" + this.nativeDbTyp_Id + ", fldr_Id=" + this.fldr_Id +
            ", is_In_SubFlow=" + this.is_In_SubFlow + ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd;
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Union [venn_Unon_Inst=" + this.venn_Unon_Inst.toString() + this.toBaseString() +
            ", vennGroups=" + VennGroupsUtil.getInstance().toString(this.vennGroups) +
            ", lAttributes=" + LAttributesUtil.getInstance().toString(this.lAttributes) +
            ", run_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes=" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes);

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind + ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd +
                ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
                ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind + ", prop_Tab_Change_Ind=" + this.prop_Tab_Change_Ind +
                ", attr_Tab_Change_Ind=" + this.attr_Tab_Change_Ind + ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind;
        }

        str += ']';
        return str;
    }
}